import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { createUserApiError } from '../../../lib/createUserApiError';
import { RestAddressAttributes } from '../fragments.rest';
import { updateAddressesCache } from '../useAddressesQuery';
import { convertAddressAttributesToRestInput } from '../convertAddressAttributesToRestInput';
import { CREATE_ADDRESS_MUTATION } from './createAddressMutation.rest';

export const useCreateAddressMutation = () => {
  const [mutate, { loading, error }] = useMutation(CREATE_ADDRESS_MUTATION, {
    update: (cache, result) => updateAddressesCache(cache, result)
  });
  const userApiError = createUserApiError(error);
  const otpEnabled = useFeatureFlag('enable-otp', [{ default: false }, { if: true, then: true }]);

  const createAddress = useCallback(
    async (address: RestAddressAttributes) => {
      const result = await mutate({
        variables: {
          input: { ...convertAddressAttributesToRestInput(address), use_otp: otpEnabled }
        }
      });
      return result.data?.createAddress.data;
    },
    [mutate, otpEnabled]
  );

  return [createAddress, { loading, error: userApiError }] as const;
};
